import React from 'react';
import classNames from 'classnames';
import { Icon } from 'ui';

class DividerButton extends React.Component {
  render() {
    const { last, addNewRuleSet } = this.props;
    const buttonStyles = classNames('tt-u', {
      'mr-4 ml-4': last,
    });

    return (
      <button type="button" disabled={!last} className="RuleDivider-button">
        {last && <Icon name="add" />}
        <span className="ml-4 RuleDivider-hoverText">{t('common.add')}</span>
        <span className={buttonStyles}>
          {addNewRuleSet ? t('common.and') : t('common.or')}
        </span>
        <span className="RuleDivider-hoverText">
          {t('smart_groups.create_modal.rule')}
        </span>
      </button>
    );
  }
}

export default DividerButton;
